//#region src/quick_add_simple_items_mode.ts
var QuickAddSimpleItemsMode = /* @__PURE__ */ function(QuickAddSimpleItemsMode) {
	QuickAddSimpleItemsMode["ShowViewButton"] = "show-view-button";
	QuickAddSimpleItemsMode["HideViewButton"] = "hide-view-button";
	QuickAddSimpleItemsMode["AddToCart"] = "add-to-cart";
	QuickAddSimpleItemsMode["AddToCartWithQuantity"] = "add-to-cart-with-quantity";
	return QuickAddSimpleItemsMode;
}(QuickAddSimpleItemsMode || {});
//#endregion
export { QuickAddSimpleItemsMode };

//# sourceMappingURL=quick_add_simple_items_mode.js.map